import React, {useState} from "react";
import Table, {TableCell, TableRow} from "@amzn/meridian/table";
import Button from "@amzn/meridian/button";
import Icon from "@amzn/meridian/icon";
import chevronDownSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-down-small";
import chevronRightSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-right-small";
import Text from "@amzn/meridian/text";
import {FormattedMessage} from "react-intl";

export const ProgramLaunchStatusTable = ({headers, contents, cumulativeProgramLaunchData, identifier, programName}) => {
    const [expandedRows, setExpandedRows] = useState([])

    const updateExpandedRows = row => {
        const newExpandedRows = expandedRows.includes(row)
            ? expandedRows.filter(expandedRow => expandedRow !== row)
            : [...expandedRows, row]

        setExpandedRows(newExpandedRows)
    }

    return (
            <Table headerRows={1} showDividers>
                        <TableRow>
                            <TableCell width={60}>
                                {/* Empty table cell to hold the expandable Icon button */}
                            </TableCell>
                            <TableCell sortColumn="name" width={["grid-6"]} columnSpan={2}>
                                <FormattedMessage id="nodeStatus.name" defaultMessage="Program Name"/>
                            </TableCell>

                            <TableCell sortColumn="type">
                                <FormattedMessage id="nodeStatus.enabled" defaultMessage="Enabled"/>
                            </TableCell>
                            <TableCell sortColumn="updatedAt">
                                <FormattedMessage id="nodeStatus.disabled" defaultMessage="Disabled"/>
                            </TableCell>
                            <TableCell sortColumn="status">
                                <FormattedMessage id="nodeStatus.partial" defaultMessage="Partially Enabled"/>
                            </TableCell>
                        </TableRow>
                { contents.length !== 0
                    ? (<TableRow>
                        <TableCell width={60} sortColumn="name"
                                   alignmentVertical="top">
                            <Button
                                type="icon"
                                size="small"
                                onClick={() => updateExpandedRows(programName)}
                            >
                                {expandedRows.includes(programName) ? (
                                    <Icon tokens={chevronDownSmallTokens}>Collapse rows</Icon>
                                ) : (
                                    <Icon tokens={chevronRightSmallTokens}>Expand rows</Icon>
                                )}
                            </Button>
                        </TableCell>
                        <TableCell alignmentVertical="top"
                                   spacingInset="none none medium none" columnSpan={2}>
                            {programName}
                        </TableCell>

                        {/*// add cumulative values here for enabled, disabled, partially enabled*/}

                        <TableCell><Text alignment={"left"}>{cumulativeProgramLaunchData.enabledStations}/{cumulativeProgramLaunchData.allStations}</Text></TableCell>
                        <TableCell><Text alignment={"left"}>{cumulativeProgramLaunchData.disabledStations}/{cumulativeProgramLaunchData.allStations}</Text></TableCell>
                        <TableCell><Text alignment={"left"}>{cumulativeProgramLaunchData.partiallyEnabledStations}/{cumulativeProgramLaunchData.allStations}</Text></TableCell>
                    </TableRow> ) :
                    <TableRow></TableRow>
                }
                {expandedRows.includes(programName) && contents.length !==0 && (
                    contents.map(featureLaunchData => (
                    <TableRow>
                        <TableCell width={60}></TableCell>
                        <TableCell></TableCell>
                        <TableCell>{featureLaunchData.FEATURE}</TableCell>
                        <TableCell>{featureLaunchData.ENABLED_STATIONS_FOR_FEATURE.length}</TableCell>
                        <TableCell>{featureLaunchData.DISABLED_STATIONS_FOR_FEATURE.length}</TableCell>
                        <TableCell>-</TableCell>
                    </TableRow>
                    )))
                }
            </Table>
    );
};


// WEBPACK FOOTER //
// ./src/components/program-launch-status/ProgramLaunchStatusTable.js